import { alpha } from "@mui/material/styles";

/** Switch styles: interactive checked = brand primary; disabled checked = pale primary (locked columns). */
export function getManageColumnsSwitchSx(primaryColor: string) {
  return {
    "& .MuiSwitch-switchBase.Mui-checked:not(.Mui-disabled)": {
      color: `${primaryColor} !important`,
    },
    "& .MuiSwitch-switchBase.Mui-checked:not(.Mui-disabled) + .MuiSwitch-track": {
      backgroundColor: `${primaryColor} !important`,
      opacity: "0.5 !important",
    },
    "& .MuiSwitch-switchBase.Mui-checked.Mui-disabled": {
      color: `${alpha(primaryColor, 0.65)} !important`,
      opacity: "1 !important",
    },
    "& .MuiSwitch-switchBase.Mui-checked.Mui-disabled + .MuiSwitch-track": {
      backgroundColor: `${alpha(primaryColor, 0.22)} !important`,
      opacity: "1 !important",
    },
    "& .MuiSwitch-track": {
      backgroundColor: "#595959 !important",
    },
  } as const;
}
